import styled from '../../../../styles/theme';
import { ModalTiresDetailStyled } from '../ModalTiresDetailStyled';
import { rem } from 'polished';

export const ModalTiresDetailStyledDS = styled(ModalTiresDetailStyled)`
    .tires-detail__link {
        color: ${({ theme }) => theme.colors.black1};
        font-size: ${({ theme }) => theme.fontSizes.h5};
        text-decoration: none;
        padding-top: ${rem(20)};
        display: block;

        svg {
            width: ${rem(12)};
            height: ${rem(12)};
            transform: rotate(-90deg);
            margin-left: ${rem(6)};

            path {
                fill: ${({ theme }) => theme.colors.black1};
            }
        }

        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.primary};
            text-decoration: underline;

            svg {
                path {
                    fill: ${({ theme }) => theme.colors.primary};
                }
            }
        }
    }
`;
